<script>
const layouts = {}
const requireContext = require.context('./layouts', false, /.*\.vue$/)
requireContext.keys().forEach(file => {
    const component = requireContext(file).default
    layouts[component.name] = component
})

export default
{
    name: 'App',

    metaInfo:
    {
        title: process.env.TITLE,
    },

    methods:
    {
        setLayout(layout)
        {
            if (!layout || !layouts[layout])
            {
                layout = this.defaultLayout
            }

            this.layout = layouts[layout]
        },

    },

    data: () => ({
        layout: null,
        defaultLayout: 'layout-main'
    }),

    mounted()
    {
        try {
          this.$store.dispatch('init')
        } catch (e) {
          console.log('Error in init:', e)
        }
    },

}
</script>

<template>
  <div id="app">
        <transition name="fade">
            <component v-if="layout" :is="layout"></component>
        </transition>
        <vue-snotify></vue-snotify>
  </div>
</template>



// WEBPACK FOOTER //
// src/App.vue